var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapVertFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.922 13.044q-.45 0-.753-.3A1 1 0 0 1 7.866 12V5.55l-1.98 1.96a1 1 0 0 1-.727.286q-.434 0-.752-.287a1.01 1.01 0 0 1-.317-.744q0-.43.317-.744l3.775-3.734a.9.9 0 0 1 .344-.222A1.2 1.2 0 0 1 8.922 2q.21 0 .396.065a.9.9 0 0 1 .343.222l3.802 3.76a.95.95 0 0 1 .304.731 1.05 1.05 0 0 1-.33.731 1.12 1.12 0 0 1-.74.3.97.97 0 0 1-.739-.3l-1.98-1.958V12q0 .444-.304.744-.303.3-.752.3M15.258 22a1.2 1.2 0 0 1-.396-.065.9.9 0 0 1-.343-.222l-3.802-3.76a.95.95 0 0 1-.303-.731q.012-.418.33-.731a1.12 1.12 0 0 1 .739-.3.97.97 0 0 1 .739.3l1.98 1.958V12q0-.444.304-.744.303-.3.752-.3.45 0 .753.3t.303.744v6.45l1.98-1.96a1 1 0 0 1 .727-.286q.435 0 .752.287.317.314.317.744t-.317.744l-3.775 3.734a.9.9 0 0 1-.344.222 1.2 1.2 0 0 1-.396.065"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapVertFill);
export default __webpack_public_path__ + "static/media/swap_vert_fill.1f60c4e8b09bb76cc2e211bca4c27bef.svg";
export { ForwardRef as ReactComponent };